import { useTriviaContext } from "../context-trivia";
import { TriviaButton } from "../TriviaButton/TriviaButton";
import { TriviaTimer } from "../TriviaQuestion/TriviaTimer";
import { TriviaFeedbackChart } from "./TriviaFeedbackChart";

export function TriviaFeedback() {
  const { config, currentQuestion, machine, playthrough, advance } =
    useTriviaContext();

  if (!currentQuestion) {
    return null;
  }

  const selection = machine.selections.find(
    (s) => s.questionId === currentQuestion.id,
  );
  const correct = !!selection?.correct;
  const isLastQuestion =
    machine.questionIndex >= playthrough.questions.length - 1;

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-[var(--trivia-space)]">
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-[var(--trivia-space)] overflow-x-hidden overflow-y-auto overscroll-contain px-[var(--trivia-space)]">
        <div
          className="hyphens-auto text-balance break-words text-center font-bold"
          style={{ fontSize: "var(--trivia-text-prompt)" }}
        >
          {currentQuestion.prompt}
        </div>
        {config.feedback.autoAdvance && (
          <div className="w-full flex-none px-[var(--trivia-space)]">
            <TriviaTimer
              totalSeconds={config.feedback.autoAdvanceSeconds}
              onEnd={advance}
            />
          </div>
        )}
        {config.feedback.showDistribution && (
          <div className="min-h-0 w-full flex-1">
            <TriviaFeedbackChart />
          </div>
        )}
        <div
          aria-live="polite"
          className="px-[calc(var(--trivia-space)*2)] py-[var(--trivia-space)] font-bold"
          style={{
            backgroundColor: correct
              ? config.theme.correctColor
              : config.theme.incorrectColor,
            color: "#ffffff",
            fontSize: "var(--trivia-text-body)",
            borderRadius: "var(--trivia-radius)",
          }}
        >
          {correct
            ? config.feedback.correctMessage
            : config.feedback.incorrectMessage}
        </div>
        {!!currentQuestion.explanation && (
          <div
            className="text-balance break-words text-center"
            style={{
              fontSize: "var(--trivia-text-meta)",
              color: config.theme.secondaryTextColor,
            }}
          >
            {currentQuestion.explanation}
          </div>
        )}
      </div>
      <div className="flex h-[max(4.5rem,12cqmin)] w-full flex-none items-center justify-center px-[var(--trivia-space)]">
        <TriviaButton
          text={isLastQuestion ? "Finish" : config.feedback.nextLabel}
          onHandleMouse={advance}
        />
      </div>
    </div>
  );
}
